import { useState, type FC, type PropsWithChildren } from "react";
import type { NotesTableContext as NotesTableContextType } from "../../types";
import { NotesTableContext } from "..";
import { useNotesTablePersistFilters } from "../use-notes-table-persist-filters";

type Props = {
  noteTableProps: NotesTableContextType["props"];
};

export const NotesTableContextProvider: FC<PropsWithChildren<Props>> = ({
  noteTableProps,
  children,
}) => {
  const { widgetId } = noteTableProps;
  const {
    date: { fromDate, setFromDate, setToDate, toDate },
    dueDate: { fromDueDate, setFromDueDate, setToDueDate, toDueDate },
  } = useNotesTablePersistFilters({ widgetId });

  const [noteFilter, setNoteFilter] = useState<string>("");
  const [titleFilter, setTitleFilter] = useState<string>("");

  return (
    <NotesTableContext.Provider
      value={{
        props: noteTableProps,
        dateFilters: {
          dateFilters: {
            fromDate: fromDate,
            setFromDate: setFromDate,
            setToDate: setToDate,
            toDate: toDate,
          },
          dueDateFilters: {
            fromDate: fromDueDate,
            setFromDate: setFromDueDate,
            setToDate: setToDueDate,
            toDate: toDueDate,
          },
        },
        searchFilters: {
          titleFilter: {
            titleFilter,
            setTitleFilter,
          },
          noteFilter: {
            noteFilter,
            setNoteFilter,
          },
        },
      }}
    >
      {children}
    </NotesTableContext.Provider>
  );
};
